import { CardContent, Icon } from "semantic-ui-react";
import { Card } from "../../UI/card"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../UI/tooltip"

const InfoMark = ({ message }) => {
  return (
    <TooltipProvider>
      <Tooltip className=''>
        <TooltipTrigger asChild>
          <span className="relative">
          <Icon name='question circle outline' size="large" className="outline-none" />
          </span>
        </TooltipTrigger>
        <TooltipContent className='absolute text-left shadow-md right-5 opacity-0 group-hover:opacity-100 border-blue-200 bg-white hidden group-hover:block w-9/12' >
          <Card className={`card border-none py-2`}>
            <CardContent className='flex items-center justify-center h-full'>
              <span className="text-lg leading-5 font-normal text-gray-700">
                {message}
              </span>
            </CardContent>
          </Card>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default InfoMark;